// @ts-nocheck

export type TenantGetWithRoom = typeof TenantGetWithRoom[keyof typeof TenantGetWithRoom];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TenantGetWithRoom = {
  true: 'true',
  false: 'false',
} as const;
